module.exports = __webpack_public_path__ + "img/ERIC KOO- BUSINESS DEVELOPMENT.8570b1bb.jpg";